import { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [clinicianUsername, setClinicianUsername] = useState("");
  const [patientUsername, setPatientUsername] = useState("");


  return (
    <UserContext.Provider value={{ clinicianUsername, setClinicianUsername, patientUsername, setPatientUsername }}>
      {children}
    </UserContext.Provider>
  );
};